// İSG uzmanı portalı — Genel Arama (header search) TanStack Query anahtarı (api-contract
// §34.3, tenant-scoped; uç kapısı `permits/list`). Tek tüketici `HeaderSearch.tsx` — anahtar
// arama metni + limit'i taşır (ikisi değişince yeniden çeker); invalidasyon gerekmez (yalnız
// okuma, hiçbir mutasyon bu veriyi değiştirmez).
//
// **`principalUuid` anahtarın PARÇASI (güvenlik düzeltmesi, security review).** §34 girişi
// "Önbellek": "sorgu anahtarı kullanıcı kimliğini İÇERİR (görünürlük kullanıcıya göre değişir —
// §30.2)" — `permits` grubu reviewer olmayanı yalnız KENDİ izinleriyle sınırlar (§30.2), yani
// AYNI `q`/`limit` iki farklı principal için FARKLI sonuç döner. `principalUuid` anahtarda
// OLMASA, bir refresh-hatası sonrası AYNI sekmede oturum açan bir SONRAKİ kullanıcı (`AppHeader.
// tsx`in `onLogout`unun ele aldığı AYNI senaryo — `queryClient.clear()` çağrılmadığı bir yol
// kalırsa) ÖNCEKİ kullanıcının önbelleğe alınmış arama sonuçlarını AĞ İSTEĞİ OLMADAN görebilirdi.
// `null`/`undefined` (principal henüz çözülmemişken — `Principal.uuid`in KENDİ tipi `string |
// null`, `uiPrefs.ts`teki AYNI sözleşme) de GEÇERLİ bir anahtar bileşenidir — `HeaderSearch`
// zaten `enabled: open && canSearch` ile sorguyu principal hazır olmadan tetiklemez, ama anahtarın
// kendisi principal'sız da tanımlı kalmalı.

import type { SearchParams } from '@isgportal/shared';

export const searchKeys = {
  /** `GET /search?q=&limit=` — principal + parametreli (trim edilmiş `q` + `limit`). */
  query: (principalUuid: string | null | undefined, params: SearchParams) =>
    ['search', principalUuid, params] as const,
};
